/**
 * Values must match GraphQL `LearningAssetType` (Phoenix: `~/types/unifiedLearningAsset.ts`).
 * KUI cannot import `~/graphql/generated`; keep this union aligned when the schema changes.
 */
export type UnifiedChatLearningAssetType = 'STORY_ASSET' | 'PATHWAY';

export const COLLECTION_TYPE = {
  CHANNEL: 'CHANNEL',
  PLAYLIST: 'PLAYLIST',
  TEACHER_PLAYLIST: 'TEACHER_PLAYLIST',
  TEACHER_TEMPLATE: 'TEACHER_TEMPLATE',
  EXPERIENCE: 'EXPERIENCE',
} as const;

export type UnifiedChatCollectionType = typeof COLLECTION_TYPE[keyof typeof COLLECTION_TYPE];

/**
 * The card model every recommendation surface shares — the coach rails, the learn catalogue and
 * the schools lesson sections all render the same asset and collection cards from it.
 *
 * `isSaved` is server-computed against the student's saved entities and travels with the
 * recommendation; the card reads it directly rather than matching against a list of saved ids. It
 * is optional because only the coach resolves it — the catalogue and lesson surfaces that reuse
 * these cards have no saved state to report, and the card treats its absence as "not saved".
 */
export type UnifiedChatContentRecommendation
  = | { id: string; name: string; slug: string; imageUrl: string; type: 'learning_asset'; learningAssetType: UnifiedChatLearningAssetType; isCompleted?: boolean; duration?: number | null; coins?: number | null; isSaved?: boolean }
    | { id: string; name: string; slug: string; imageUrl: string; type: 'learning_asset_collection'; collectionType: UnifiedChatCollectionType; completedCount: number; totalCount: number; partnerLogoUrl?: string; partnerName?: string; duration?: number | null; coins?: number | null; isSaved?: boolean };
